// @core/api/endpoints/affiliate/get_affiliate.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  AffiliateResponse,
} from '../../../types/affiliate';

const BASE_PATH = '/affiliate';

/**
 * Get affiliate by ID
 * Retrieves affiliate by the specified identifier.
 */
export async function GetAffiliate(
  affiliate_id: string,
  options?: RequestOptions
): Promise<AffiliateResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/affiliates/:affiliate_id`;
  requestPath = requestPath.replace(':affiliate_id', encodeURIComponent(affiliate_id));
  const requestOptions = options;
  return client.get<AffiliateResponse>(requestPath, { ...requestOptions });
}
